import client from './client';
import { getCache, setCache } from '../utils/apiCache';

export interface HeroSlider {
    id: number;
    image: string;
    alt: string | null;
    link: string | null;
}

export const fetchHeroSliders = async (): Promise<HeroSlider[]> => {
    const cacheKey = 'hero_sliders';
    const cachedData = getCache<HeroSlider[]>(cacheKey);
    if (cachedData) return cachedData;

    try {
        const response = await client.get<HeroSlider[]>('/hero-sliders');
        setCache(cacheKey, response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching hero sliders:', error);
        return [];
    }
};
